<template>
  <div>
    <BaseModal v-model="show" title="账户充值" :width="420">
      <template v-if="!code">
        <a-alert message="请输入充值金额。单位：元（人民币）" show-icon type="warning"/>
        <a-row :gutter="20" style="margin-top:20px;">
          <a-col span="16">
            <a-input-number v-model="form.amount" step="10" :min="1" style="width:100%;"/>
          </a-col>
          <a-col span="8">
            <a-button type="primary" block @click="ensure" :loading="loading">确认充值</a-button>
          </a-col>
        </a-row>
      </template>
      <template v-else>
        <a-alert show-icon type="warning">
          <template slot="message">
            充值人民币{{ form.amount|formatCNY }}。<a @click="change">更换金额</a>
          </template>
        </a-alert>
        <a-row :gutter="20" style="margin-top:20px;">
          <a-col span="12">
            <div class="qrcode">
              <img :src="code" width="160" height="160"/>
              <div>微信扫码支付</div>
            </div>
          </a-col>
          <a-col span="12">
            <div class="qrcode">
              <img src="@/assets/waiting.jpg" width="160" height="160"/>
              <div>支付宝扫码支付</div>
            </div>
          </a-col>
        </a-row>
      </template>
    </BaseModal>
    <a-button type="primary" icon="pay-circle" @click="open">账户充值</a-button>
  </div>
</template>

<script>
import api from "@/utils/api";
import func from "@/utils/func";
import BaseModal from "@/comps/BaseModal";
import DelayLoading from "@/comps/DelayLoading";

export default {
  name: "ChargeButton",
  mixins: [DelayLoading],
  components: {BaseModal},
  data() {
    return {
      show: false,
      form: {
        amount: 100,
        channel: 15, // 扫码支付
        app_flag: "efoto.h5.trade.pay",
      },
      code: "", // 支付二维码
      probeTimeId: null,
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    change() {
      this.code = "";
    },
    ensure() {
      const self = this;
      clearTimeout(this.probeTimeId);
      this.withLoading(300, () => {
        return api.v1.user.charge.create(this.form).then(res => {
          self.code = api.v1.support.qrCode(res["pay_args"]["code_url"], 200);
          self.probePaid(res.info["trade_no"]); // 探测
        });
      });
    },
    async probePaid(id) {
      let res = await api.v1.user.charge.isPaid(id);
      if (res["is_paid"] === true) {
        window.location.reload(); // 刷新页面
      }
      this.probeTimeId = func.setTimeout(2000, () => this.probePaid(id));
    }
  }
}
</script>

<style scoped lang="less">
.qrcode {
  padding: 6px;
  text-align: center;
  border-radius: 3px;
  border: 1px #ddd solid;

  img {
    max-width: 100%;
    margin-bottom: 8px;
  }
}
</style>